import React, { useState } from 'react';
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom';
import { PageHeader } from '../../../components/StandardPage';
import { TypeMainOutlet } from '..';
import DreLineModal from './DreLineModal';
import { DreLinesOutletContext } from './types';
import { ListContent } from './style';
import { FINANCIAL_TAB_DRE, financialSectionTabs } from '../financialSectionTabs';

const DreLinesLayout: React.FC = () => {
  const parentContext = useOutletContext<TypeMainOutlet>();
  const navigate = useNavigate();
  const search = parentContext?.search ?? '';

  const [refreshKey, setRefreshKey] = useState(0);
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const triggerRefresh = () => setRefreshKey((key) => key + 1);

  const outletContext: DreLinesOutletContext = {
    search,
    refreshKey,
    triggerRefresh,
  };

  return (
    <>
      <PageHeader
        title="Financeiro"
        tableName="DreLine"
        moduleName="Linhas do DRE"
        tabs={financialSectionTabs.map(({ key, label, icon }) => ({
          key,
          label,
          icon,
        }))}
        activeTab={FINANCIAL_TAB_DRE}
        onTabChange={(key) => {
          const tab = financialSectionTabs.find((item) => item.key === key);
          if (tab) navigate(tab.path);
        }}
        onReload={triggerRefresh}
        createButton={{
          label: 'Nova linha',
          onClick: () => setIsCreateOpen(true),
        }}
      />

      <ListContent>
        <Outlet context={outletContext} />
      </ListContent>

      {isCreateOpen && (
        <DreLineModal
          onClose={() => setIsCreateOpen(false)}
          onSaved={triggerRefresh}
        />
      )}
    </>
  );
};

export default DreLinesLayout;
